import { Mapper } from "../../../../../base/utils/mapper";
import { ThirdCompanyResponseEntity } from "../../entities/company/third-company.entity";
import { ThirdCompanyResponseModel } from '../../../../../domain/models/configuration/company/third-company.model';

export class ThirdCompanyImplementationRepositoryMapper extends Mapper<ThirdCompanyResponseEntity, ThirdCompanyResponseModel> {
    mapFrom(param: ThirdCompanyResponseEntity): ThirdCompanyResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ThirdCompanyResponseModel): ThirdCompanyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}